import React, { ComponentProps } from 'react';
import { Flex, Box, Typography, Tooltip, Badge } from '@fullstory/components';
import css from './index.module.scss';
import { FGACButton } from '../FGACButton';
import { FormattedMessage } from 'react-intl';

export interface ResourceHeaderProps
  extends Pick<ComponentProps<typeof FGACButton>, 'tooltip' | 'tooltipPlacement'> {
  title: string;
  subTitle: string;
  helpText: string;
  buttonText: string;
  onCreate: () => void;
  restricted?: boolean;
  beta?: boolean;
}

export const ResourceHeader: React.FC<ResourceHeaderProps> = ({
  title,
  subTitle,
  helpText,
  buttonText,
  onCreate,
  restricted,
  beta,
  ...FGACButtonProps
}) => (
  <Box data-component="ResourceHeader" margin={[16, 0, 32, 0]}>
    <Flex justifyContent="space-between" alignItems="center">
      <Box>
        <Flex>
          <Box padding={[0, 8, 0, 8]}>
            <Typography variant="title3">{title}</Typography>
          </Box>
          <Box padding={[0, 8, 0, 8]}>
            <Tooltip placement="right" tooltipContent={helpText} offset={8}>
              <Typography
                className={css.defaultCursor}
                variant="body2"
                color="neutrals-n7"
                underline="dashed"
                fontStyle="italic"
              >
                {subTitle}
              </Typography>
            </Tooltip>
          </Box>
          {beta && (
            <Box padding={[0, 8, 0, 8]}>
              <Badge variant="brand">
                <FormattedMessage defaultMessage="Beta" id="riw/yc" />
              </Badge>
            </Box>
          )}
        </Flex>
      </Box>
      <FGACButton
        iconOnly={false}
        size="medium"
        variant="fill-primary"
        onClick={onCreate}
        disabled={restricted}
        {...FGACButtonProps}
      >
        {buttonText}
      </FGACButton>
    </Flex>
  </Box>
);
